import "./Agents.scss";

import AgentImg1 from "../../assets/images/agent-1.png";
import AgentImg2 from "../../assets/images/agent-2.png";
import AgentImg3 from "../../assets/images/agent-3.png";
import AgentImg4 from "../../assets/images/agent-4.png";

import AgentDecoration from "../../assets/images/agent-decoration.png";

export default function Agents() {
	return (
		<div className="agents">
			<div className="agents-content-wrapper content-wrapper-lg">
				<div className="agent-cards-wrapper">
					<ul className="agent-cards row">
						<li
							className="agent-card-item"
							data-aos="fade-up-right"
						>
							<div className="agent-card">
								<img
									className="decoration agent-decoration"
									src={AgentDecoration}
									alt="Agent Decoration"
								/>
								
								<div className="agent-card-img">
									<img src={AgentImg1} alt="Agent" />
								</div>
								<div className="agent-card-title">Retina</div>
								<div className="agent-card-desc">
									Retina is an Al-powered research assistant
									that quickly analyzes and summarizes
									information from multiple sources, helping
									you uncover key insights and make informed
									decisions efficiently.
								</div>
							</div>
						</li>
						<li className="agent-card-item" data-aos="fade-up-left">
							<div className="agent-card">
								<div className="agent-card-img">
									<img src={AgentImg2} alt="Agent" />
								</div>
								<div className="agent-card-title">Sclera</div>
								<div className="agent-card-desc">
									Sclera is a dedicated business analyst that
									simplifies processes and enhances
									decision-making by analyzing trends,
									reviewing financial data, and providing
									actionable insights.
								</div>
							</div>
						</li>
						<li
							className="agent-card-item"
							data-aos="fade-up-right"
						>
							<div className="agent-card">
								<div className="agent-card-img">
									<img src={AgentImg3} alt="Agent" />
								</div>
								<div className="agent-card-title">Fovea</div>
								<div className="agent-card-desc">
									Fovea is an autonomous trading assistant
									designed to optimize market strategies by
									analyzing trends, executing trades, and
									managing portfolios with real-time
									decision-making.
								</div>
							</div>
						</li>
						<li className="agent-card-item" data-aos="fade-up-left">
							<div className="agent-card">
								<img
									className="decoration agent-decoration"
									src={AgentDecoration}
									alt="Agent Decoration"
								/>

								<div className="agent-card-img">
									<img src={AgentImg4} alt="Agent" />
								</div>
								<div className="agent-card-title">Cornea</div>
								<div className="agent-card-desc">
									Cornea is an intuitive Al-powered assistant
									that streamlines content creation, allowing
									you to generate, customize, and optimize
									content across various platforms quickly
									while maintaining brand consistency.
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
